import React from "react";
import { Link } from "react-router-dom";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Box,
    Typography
} from "@mui/material";
import { MdExpandMore } from "react-icons/md";
import "./MobileMenuOverlay.css";

export default function MobileMenuOverlay({
    open,
    onClose,
    menuConfig,
    singleMenuItems,
    RolePermission,
    currentDevice
}) {
    const [expandedMenu, setExpandedMenu] = React.useState(null);

    const handleAccordionChange = (panel) => (_, isExpanded) => {
        setExpandedMenu(isExpanded ? panel : null);
    };

    const isDeviceAllowed = (moduleKey) => {
        if (!moduleKey) return true;

        const moduleData = RolePermission?.[moduleKey];

        if (!moduleData?.allowed_devices) return true;

        return !!moduleData.allowed_devices[currentDevice];
    };

    const isVisible = (entry) =>
        entry.permission(RolePermission) &&
        isDeviceAllowed(entry.moduleKey);

    return (
        <div
            className={`mobileMenuOverlay ${
                open ? "mobileMenuOverlayOpen" : ""
            }`}
        >
            <div
                className={`mobileMenuPanel ${
                    open ? "mobileMenuPanelOpen" : ""
                }`}
            >
                {menuConfig
                    .filter(isVisible)
                    .map((menu) => {
                        const MenuIcon = menu.icon;

                        const visibleItems = menu.items.filter(isVisible);

                        if (!visibleItems.length) return null;

                        return (
                            <Accordion
                                key={menu.key}
                                expanded={expandedMenu === menu.key}
                                onChange={handleAccordionChange(menu.key)}
                                disableGutters
                                elevation={0}
                                square
                                className="mobileAccordion"
                            >
                                <AccordionSummary
                                    expandIcon={<MdExpandMore />}
                                    className="accordionHeader"
                                >
                                    <div className="left">
                                        <MenuIcon />
                                        <span>{menu.label}</span>
                                    </div>
                                </AccordionSummary>

                                <AccordionDetails sx={{ bgcolor: "#fafafa", py: 2 }}>
                                    <Grid container spacing={2}>
                                        {visibleItems.map((item) => {
                                            const Icon = item.icon;

                                            return (
                                                <Grid
                                                    item
                                                    xs={3}
                                                    sm={2.4}
                                                    md={2}
                                                    key={item.path}
                                                >
                                                    <Link
                                                        to={item.path}
                                                        onClick={onClose}
                                                        style={{
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: 56,
                                                                    height: 56,
                                                                    borderRadius: 3,
                                                                    bgcolor: "#fff",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                                                                    transition: "all .25s",
                                                                    "&:hover": {
                                                                        bgcolor: "#d71920",
                                                                        color: "#fff",
                                                                    },
                                                                }}
                                                            >
                                                                <Icon size={24} color="var(--primary)"/>
                                                            </Box>

                                                            <Typography
                                                                variant="caption"
                                                                align="center"
                                                                sx={{
                                                                    mt: 1,
                                                                    lineHeight: 1.3,
                                                                    fontSize: 12,
                                                                    color: "#444",
                                                                }}
                                                            >
                                                                {item.label}
                                                            </Typography>
                                                        </Box>
                                                    </Link>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })}

                {singleMenuItems
                    .filter(isVisible)
                    .map((item) => {
                        const Icon = item.icon;

                        return (
                            <Link
                                key={item.key}
                                to={item.path}
                                className="mobileSingleMenu"
                                onClick={onClose}
                            >
                                <div className="left">
                                    <Icon />
                                    <span>{item.label}</span>
                                </div>
                            </Link>
                        );
                    })}
            </div>
        </div>
    );
}